import React, { FC, useCallback, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';
import { openLoginDialog, openRegistrationDialog } from 'app/modules/Signing/actions';
import { createSigningQuery } from 'app/modules/Signing/utils/signing-modals-query';

import { ModalSigningTab } from '../constants';
import { AuthContext } from '../context';
import Authorization from './Authorization';
import Header from './Header';
import Registration from './Registration';

import styles from '../Signing.module.scss';

const Content: FC = () => {
  const { authData, setAuthData } = useContext(AuthContext);
  const { search } = useLocation();
  const dispatch = useDispatch();
  const isAllowReg = useFeatureFlag(FeatureFlag.ALLOW_REGISTRATION);
  const isLoginTab = search.startsWith(createSigningQuery('login'));
  const isRegistrationTab = search.startsWith(createSigningQuery('registration')) && isAllowReg;

  const activeTab = (
    isRegistrationTab && ModalSigningTab.REGISTRATION
  ) || ModalSigningTab.AUTHORIZATION;

  const { errorMessage, shake } = authData;

  const handleChangeTab = useCallback((tab: ModalSigningTab) => {
    if (tab === ModalSigningTab.REGISTRATION && errorMessage) {
      setAuthData((prevState) => ({
        ...prevState,
        errorMessage: false,
        showFieldError: false,
        shake: false,
      }));
    }

    if (tab === ModalSigningTab.REGISTRATION) {
      dispatch(openRegistrationDialog());
    }
    else {
      dispatch(openLoginDialog());
    }
  }, [errorMessage, search]);

  const contentClassnames = classNames(styles.loginModalContent, {
    [styles.shake]: shake,
  });

  return (
    <div className={contentClassnames}>
      <Header activeTab={activeTab}
              changeTab={handleChangeTab} />

      {isLoginTab && (
        <Authorization />
      )}

      {isRegistrationTab && (
        <Registration />
      )}
    </div>
  );
};

export default Content;
